import { render, staticRenderFns } from "./today-promotions.vue?vue&type=template&id=da63cb20&"
import script from "./today-promotions.vue?vue&type=script&lang=js&"
export * from "./today-promotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports